// extracted by mini-css-extract-plugin
export default {"container":"MultiPhoneBlacklist_container__iJx+v"};